export default __webpack_public_path__ + "static/media/background_cesbron.fe3bae1f.png";